import authRoles from "../../utils/auth.roles";
const { default: NotFound } = require("./NotFound");

const NotFoundRoutes = {
  auth: authRoles.guest,
  kyc: false,
  mfaNotRequired: true, 
  routes: [
    {
      path: "/error/:code",
      exact: true,
      component: NotFound,
    },
  ],
};
export default NotFoundRoutes;
